import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  width: 100%;
  max-width: 1190px;
  padding: 31px 24px;
  margin: 0 auto;
  background: ${theme.backgrounds.backgroundFour};
`
export const headerContainer = (theme: Theme) => css`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: ${theme.spacing(1, 0, 3)};

  ${theme.breakpoints.down(580)} {
    flex-direction: column;
    gap: ${theme.spacing(1)};
    align-items: end;
  }
`

export const title = (theme: Theme) => css`
  height: 42px;
  line-height: 42px;
  font-weight: 700;

  ${theme.breakpoints.down(580)} {
    width: 100%;
  }
`

export const headerWrapper = (theme: Theme) => css`
  ${theme.breakpoints.down(580)} {
    width: 100%;
    flex-direction: column;
    align-items: end;
  }
`

export const search = (theme: Theme) => css`
  ${theme.breakpoints.down(580)} {
    width: 100%;
  }
`

export const plusIcon = css`
  width: 20px !important;
  height: 20px !important;
`
